var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-card', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "base-rate-block"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('label', [_vm._v("Tariff Card List "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v("  "), _c('span', {
    staticClass: "small-text"
  }, [_vm._v(" (Choose a pre-defined tariff card)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-credit-card'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: _vm.initialTariffcardId != null ? false : true
      }),
      expression: "{required: initialTariffcardId!=null?false:true}"
    }],
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.tariffCardList,
      "placeholder": "Select Tariff Card",
      "append-to-body": true,
      "name": "TariffCard",
      "disabled": _vm.initialTariffcardId != null ? true : false
    },
    on: {
      "select": _vm.selectCard
    },
    model: {
      value: (_vm.tarrifCardModel),
      callback: function($$v) {
        _vm.tarrifCardModel = $$v
      },
      expression: "tarrifCardModel"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('TariffCard')),
      expression: "errors.has('TariffCard')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please choose Tariff Card.")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tarifftype),
      expression: "tarifftype"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Tariff Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-credit-card'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tarifftype),
      expression: "tarifftype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "tarifftype",
      "name": "Tariff Type",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.tarifftype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tarifftype = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slabtype),
      expression: "slabtype"
    }],
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Slab Type")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-credit-card'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slabtype),
      expression: "slabtype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "id": "slabtype",
      "name": "Slab Type",
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.slabtype)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.slabtype = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), (_vm.tarifftype == 'slab') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-input-group', [_c('label', [_vm._v("Slab Charge Type"), _c('span', {
    staticClass: "required"
  }, [_vm._v(" *")])]), _vm._v("     \n          "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baserateslabchargetype),
      expression: "baserateslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('baserateslabchargetype')
    },
    attrs: {
      "type": "radio",
      "id": "Incremental",
      "value": "1",
      "name": "baserateslabchargetype"
    },
    domProps: {
      "checked": _vm._q(_vm.baserateslabchargetype, "1")
    },
    on: {
      "click": function($event) {
        _vm.changebaserateslabchargetype()
      },
      "__c": function($event) {
        _vm.baserateslabchargetype = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Incremental"
    }
  }, [_vm._v("Incremental ")]), _vm._v("     \n            "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baserateslabchargetype),
      expression: "baserateslabchargetype"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('baserateslabchargetype')
    },
    attrs: {
      "type": "radio",
      "id": "Absolute",
      "value": "2",
      "name": "baserateslabchargetype"
    },
    domProps: {
      "checked": _vm._q(_vm.baserateslabchargetype, "2")
    },
    on: {
      "click": function($event) {
        _vm.changebaserateslabchargetype()
      },
      "__c": function($event) {
        _vm.baserateslabchargetype = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "Absolute"
    }
  }, [_vm._v("Absolute")]), _vm._v("     \n          ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('baserateslabchargetype')),
      expression: "errors.has('baserateslabchargetype')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Please select Slab Charge Type.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "slabcharge"
    }
  }, [_vm._v("Note: For Incremental, the charges will be calculated for each Slab Break. For Absolute, the entire charges will be calculated for the Slab the AWB belongs to.")])])]) : _vm._e(), _vm._v(" "), (_vm.callFrom.name == 'client-contract-template') ? _c('b-card', [_c('h4', {
    staticClass: "header"
  }, [_vm._v("Update Rate TAT")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UpdateRateTatType),
      expression: "UpdateRateTatType"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "TariffCardTemplate",
      "value": "TariffCardTemplate",
      "name": "UpdateRateTat",
      "disabled": _vm.UpdateRateTatType == 'FileUpload' ? true : false
    },
    domProps: {
      "checked": _vm._q(_vm.UpdateRateTatType, "TariffCardTemplate")
    },
    on: {
      "change": function($event) {
        _vm.onChangeUpdateRateTatType()
      },
      "__c": function($event) {
        _vm.UpdateRateTatType = "TariffCardTemplate"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "TariffCardTemplate"
    }
  }, [_vm._v("Select Another Template ")]), _vm._v("     \n              ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', {
    attrs: {
      "left": "<i class=\"fa fa-level-up\"></i>"
    }
  }, [_c('treeselect', {
    attrs: {
      "clearable": false,
      "multiple": false,
      "max-height": 200,
      "options": _vm.tariffCardList,
      "placeholder": "Select Tariff Card",
      "append-to-body": true,
      "disabled": _vm.UpdateRateTatType == 'TariffCardTemplate' ? false : true
    },
    on: {
      "select": _vm.selectNewCard
    },
    model: {
      value: (_vm.AnotherTariffCard),
      callback: function($$v) {
        _vm.AnotherTariffCard = $$v
      },
      expression: "AnotherTariffCard"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UpdateRateTatType),
      expression: "UpdateRateTatType"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "radio",
      "id": "UploadFile",
      "value": "FileUpload",
      "name": "UpdateRateTat",
      "disabled": _vm.UpdateRateTatType == 'TariffCardTemplate' ? true : false
    },
    domProps: {
      "checked": _vm._q(_vm.UpdateRateTatType, "FileUpload")
    },
    on: {
      "change": function($event) {
        _vm.onChangeUpdateRateTatType()
      },
      "__c": function($event) {
        _vm.UpdateRateTatType = "FileUpload"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "UploadFile"
    }
  }, [_vm._v("Upload File")])])])])], 1)]), _vm._v(" "), (_vm.servicetype == 1) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.tarifftype == 'flat' && _vm.UpdateRateTatType == 'FileUpload') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    },
    attrs: {
      "for": "FileUpload"
    }
  }, [_c('a', {
    staticClass: "-btn btn-info"
  }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "FileUpload",
      "name": "FileUpload",
      "accept": ".csv",
      "type": "file",
      "disabled": _vm.UpdateRateTatType == 'FileUpload' ? false : true
    },
    on: {
      "click": function($event) {
        $event.target.value = null
      },
      "change": function($event) {
        _vm.chooseFile($event, 0)
      }
    }
  }), _vm._v("  \n              "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedData[0].filename))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Rate"
    },
    on: {
      "click": function($event) {
        _vm.downloadRateTemplate()
      }
    }
  }, [_vm._v("Download Rate Template(City to City)")])]) : _vm._e()]), _vm._v(" "), (_vm.validatedData[0].isfilechose && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.validatedData[0].isDisable,
      "title": "Validate File"
    },
    on: {
      "click": function($event) {
        _vm.validateTariff(0, 0)
      }
    }
  }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].isvalidationdone && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].isvalidationdone && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].invaliddata > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Invalid records details:")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Download (CSV)"
    },
    on: {
      "click": function($event) {
        _vm.downloadInvalidData(0)
      }
    }
  }, [_vm._v("Download (CSV)")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[0].invaliddata > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumnFlat,
      "items": _vm.validatedData[0].tableItems,
      "offset": _vm.validatedData[0].offset
    }
  }), _vm._v(" "), _c('pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validatedData[0].totalPage > 1),
      expression: "validatedData[0].totalPage>1"
    }],
    staticClass: "slabPagination",
    attrs: {
      "total-pages": _vm.validatedData[0].totalPage,
      "total": _vm.validatedData[0].totalCount,
      "per-page": _vm.validatedData[0].pageLimit,
      "current-page": _vm.validatedData[0].currentPage
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange($event, 0)
      }
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 2) ? _c('div', [_c('div', {
    staticClass: "form-group row"
  }, [(_vm.tarifftype == 'flat' && _vm.UpdateRateTatType == 'FileUpload') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    },
    attrs: {
      "for": "ZoneFileUpload"
    }
  }, [_c('a', {
    staticClass: "-btn btn-info"
  }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
    ref: "zonefile",
    attrs: {
      "id": "ZoneFileUpload",
      "name": "ZoneFileUpload",
      "accept": ".csv",
      "type": "file",
      "disabled": _vm.UpdateRateTatType == 'FileUpload' ? false : true
    },
    on: {
      "click": function($event) {
        $event.target.value = null
      },
      "change": function($event) {
        _vm.chooseZoneFile($event, 0)
      }
    }
  }), _vm._v("  \n              "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedDataZonetoZone[0].filename))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Rate"
    },
    on: {
      "click": function($event) {
        _vm.downloadRateTemplateZone()
      }
    }
  }, [_vm._v("Download Rate Template(Zone to Zone)")])]) : _vm._e()]), _vm._v(" "), (_vm.validatedDataZonetoZone[0].isfilechose && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.validatedDataZonetoZone[0].isDisable,
      "title": "Validate File"
    },
    on: {
      "click": function($event) {
        _vm.validateZoneTariff(0, 0)
      }
    }
  }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedDataZonetoZone[0].isvalidationdone && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedDataZonetoZone[0].isvalidationdone && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedDataZonetoZone[0].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedDataZonetoZone[0].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedDataZonetoZone[0].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.validatedDataZonetoZone[0].invaliddata > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumnsZoneFlat,
      "items": _vm.validatedDataZonetoZone[0].tableItems,
      "offset": _vm.validatedDataZonetoZone[0].offset
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox",
    attrs: {
      "left": "<i class='fa fa-credit-card'></i>"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addcities),
      expression: "addcities"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "checkbox",
      "name": "exceptionalcities",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.addcities) ? _vm._i(_vm.addcities, "true") > -1 : (_vm.addcities)
    },
    on: {
      "click": function($event) {
        _vm.getexceptionalcitiesservicedetails()
      },
      "__c": function($event) {
        var $$a = _vm.addcities,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.addcities = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.addcities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.addcities = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "exceptionalcities"
    }
  }, [_vm._v("Upload Exceptional Lanes    ")])])]), _vm._v(" "), (_vm.additionalCitiesDownloadTemplateLength > 0 && _vm.tarifftype == 'flat' && _vm.addcities) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Rate"
    },
    on: {
      "click": function($event) {
        _vm.downloadExceptionalCities()
      }
    }
  }, [_vm._v("Download Exceptional Lane Template")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.tarifftype == 'flat' && _vm.addcities) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "file-upload"
  }, [_c('label', {
    staticStyle: {
      "color": "#fff",
      "cursor": "pointer"
    },
    attrs: {
      "for": "ExceptionalCitiesUpload"
    }
  }, [_c('a', {
    staticClass: "-btn btn-info"
  }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "ExceptionalCitiesUpload",
      "name": "ExceptionalCitiesUpload",
      "accept": ".csv",
      "type": "file"
    },
    on: {
      "click": function($event) {
        $event.target.value = null
      },
      "change": function($event) {
        _vm.chooseFile($event, 0, 0)
      }
    }
  }), _vm._v("  \n              "), _c('span', {
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedData[0].filename))])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.addcities && _vm.validatedData[0].isfilechose && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.validatedData[0].isDisable,
      "title": "Validate File"
    },
    on: {
      "click": function($event) {
        _vm.validateTariff(0, 0)
      }
    }
  }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[0].isvalidationdone && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[0].isvalidationdone && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" " + _vm._s(_vm.validatedData[0].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[0].invaliddata > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Invalid records details:")]), _vm._v(" "), _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right",
      "padding-right": "2px",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "title": "Download (CSV)"
    },
    on: {
      "click": function($event) {
        _vm.downloadInvalidData(0)
      }
    }
  }, [_vm._v("Download (CSV)")])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[0].invaliddata > 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('custom-expandable-table', {
    attrs: {
      "columns": _vm.tableColumnFlat,
      "items": _vm.validatedData[0].tableItems,
      "offset": _vm.validatedData[0].offset
    }
  }), _vm._v(" "), _c('pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.validatedData[0].totalPage > 1),
      expression: "validatedData[0].totalPage>1"
    }],
    staticClass: "slabPagination",
    attrs: {
      "total-pages": _vm.validatedData[0].totalPage,
      "total": _vm.validatedData[0].totalCount,
      "per-page": _vm.validatedData[0].pageLimit,
      "current-page": _vm.validatedData[0].currentPage
    },
    on: {
      "pagechanged": function($event) {
        _vm.onPageChange($event, 0)
      }
    }
  })], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength == 0 && _vm.tarifftype == 'flat') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Rate"
    },
    on: {
      "click": function($event) {
        _vm.createCsvForDownload()
      }
    }
  }, [_vm._v(_vm._s(_vm.servicetype == 1 ? 'Download Rate (City to City)' : 'Download Rate (Zone to Zone)'))])])]) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength == 0 && _vm.tarifftype == 'flat' && _vm.isExceptionalcitiespresent) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('button', {
    staticClass: "-btn btn-link",
    attrs: {
      "type": "button",
      "title": "Download Rate"
    },
    on: {
      "click": function($event) {
        _vm.createCsvForDownload(null, true)
      }
    }
  }, [_vm._v("Download Rate (Exceptional Lanes)")]), _c('span', [_c('button', {
    staticClass: "-btn btn-link",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "type": "button",
      "title": "Download Rate"
    },
    on: {
      "click": function($event) {
        _vm.removeExceptionalCities()
      }
    }
  }, [_vm._v("Remove")])])])]) : _vm._e(), _vm._v(" "), (_vm.tarifftype == 'slab') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Define Rate")]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, _vm._l((_vm.matrixSlabHeaderArray), function(val, index) {
    return _c('div', {
      staticClass: "tab"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": 'chck' + val.id
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "tab-label",
      attrs: {
        "for": 'chck' + val.id
      }
    }, [_vm._v("Break " + _vm._s(val.id) + " " + _vm._s(_vm.slabtype == "Weight" ? '(Billable weight (kg)' : '(Quantity (Number of boxes)') + ": " + _vm._s(val.name) + ")")]), _vm._v(" "), (_vm.servicetype == 1) ? _c('div', {
      staticClass: "tab-content",
      staticStyle: {
        "overflow": "auto",
        "overflow-x": "auto"
      }
    }, [(_vm.UpdateRateTatType == 'FileUpload') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + index
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + index,
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file",
        "disabled": _vm.UpdateRateTatType == 'FileUpload' ? false : true
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFile($event, index, 1)
        }
      }
    }), _vm._v("  \n                      "), _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedData[index].filename))])])])], 1), _vm._v(" "), (_vm.ratetemplatelength > 0) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.downloadRateTemplate(val.lowerlimit, val.higherlimit)
        }
      }
    }, [_vm._v("Download Rate Template")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength == 0 && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.createCsvForDownload(index)
        }
      }
    }, [_vm._v("Download Rate (Zone to Zone)")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isfilechose) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "disabled": _vm.validatedData[index].isDisable,
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateTariff(val, index)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isvalidationdone) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].isvalidationdone) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("  " + _vm._s(_vm.validatedData[index].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedData[index].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.validatedData[index].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].invaliddata > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")]), _vm._v(" "), _c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "float": "right",
        "padding-right": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Download (CSV)"
      },
      on: {
        "click": function($event) {
          _vm.downloadInvalidData(index)
        }
      }
    }, [_vm._v("Download (CSV)")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedData[index].invaliddata > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.tableColumnSlab,
        "items": _vm.validatedData[index].tableItems,
        "offset": _vm.validatedData[index].offset
      }
    }), _c('br'), _vm._v(" "), _c('pagination', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validatedData[index].totalPage > 1),
        expression: "validatedData[index].totalPage>1"
      }],
      staticClass: "slabPagination",
      attrs: {
        "total-pages": _vm.validatedData[index].totalPage,
        "total": _vm.validatedData[index].totalCount,
        "per-page": _vm.validatedData[index].pageLimit,
        "current-page": _vm.validatedData[index].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, index)
        }
      }
    })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.servicetype == 2) ? _c('div', {
      staticClass: "tab-content",
      staticStyle: {
        "overflow": "auto",
        "overflow-x": "auto"
      }
    }, [_c('div', {
      staticClass: "form-group row"
    }, [(_vm.tarifftype == 'slab' && _vm.UpdateRateTatType == 'FileUpload') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'ZoneFileUpload' + index
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File For Zone to Zone")])]), _vm._v(" "), _c('input', {
      ref: "zonefile",
      refInFor: true,
      attrs: {
        "id": 'ZoneFileUpload' + index,
        "name": "ZoneFileUpload",
        "accept": ".csv",
        "type": "file",
        "disabled": _vm.UpdateRateTatType == 'FileUpload' ? false : true
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseZoneFile($event, index, 1)
        }
      }
    }), _vm._v("  \n                      "), _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedDataZonetoZone[index].filename))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength > 0 && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.downloadRateTemplateZone()
        }
      }
    }, [_vm._v("Download Rate Template(Zone to Zone)")])]) : _vm._e()]), _vm._v(" "), (_vm.validatedDataZonetoZone[index].isfilechose && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "disabled": _vm.validatedDataZonetoZone[index].isDisable,
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateZoneTariff(index)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedDataZonetoZone[index].isvalidationdone && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.validatedDataZonetoZone[index].isvalidationdone && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedDataZonetoZone[index].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedDataZonetoZone[index].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.validatedDataZonetoZone[index].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.validatedDataZonetoZone[index].invaliddata > 0 && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.tableColumnsZoneFlat,
        "items": _vm.validatedDataZonetoZone[index].tableItems,
        "offset": _vm.validatedDataZonetoZone[index].offset
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [(_vm.tarifftype == 'slab' && _vm.addcities) ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'ExceptionalCitiesUpload' + index
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File for Exceptional Lane")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'ExceptionalCitiesUpload' + index,
        "name": "ExceptionalCitiesUpload",
        "accept": ".csv",
        "type": "file"
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFile($event, index, 1)
        }
      }
    }), _vm._v("  \n                      "), _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v("Chosen File: " + _vm._s(_vm.validatedData[index].filename))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.additionalCitiesDownloadTemplateLength > 0 && _vm.tarifftype == 'slab' && _vm.addcities) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.downloadExceptionalCities(val.lowerlimit, val.higherlimit)
        }
      }
    }, [_vm._v("Download Exceptional Cities Template")])]) : _vm._e()]), _vm._v(" "), (_vm.addcities && _vm.validatedData[index].isfilechose && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "disabled": _vm.validatedData[index].isDisable,
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateTariff(val, index)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[index].isvalidationdone && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[index].isvalidationdone && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedData[index].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.validatedData[index].validdata))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.validatedData[index].invaliddata))])])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[index].invaliddata > 0 && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")]), _vm._v(" "), _c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "float": "right",
        "padding-right": "2px",
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Download (CSV)"
      },
      on: {
        "click": function($event) {
          _vm.downloadInvalidData(index)
        }
      }
    }, [_vm._v("Download (CSV)")])])]) : _vm._e(), _vm._v(" "), (_vm.addcities && _vm.validatedData[index].invaliddata > 0 && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.tableColumnFlat,
        "items": _vm.validatedData[index].tableItems,
        "offset": _vm.validatedData[index].offset
      }
    }), _vm._v(" "), _c('pagination', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.validatedData[index].totalPage > 1),
        expression: "validatedData[index].totalPage>1"
      }],
      staticClass: "slabPagination",
      attrs: {
        "total-pages": _vm.validatedData[index].totalPage,
        "total": _vm.validatedData[index].totalCount,
        "per-page": _vm.validatedData[index].pageLimit,
        "current-page": _vm.validatedData[index].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, index)
        }
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength == 0 && _vm.tarifftype == 'slab') ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.createCsvForDownload(index)
        }
      }
    }, [_vm._v("Download Rate (Zone to Zone)")])])]) : _vm._e(), _vm._v(" "), (_vm.ratetemplatelength == 0 && _vm.tarifftype == 'slab' && _vm.isExceptionalcitiespresent) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.createCsvForDownload(index, true)
        }
      }
    }, [_vm._v("Download Rate (Exceptional Lanes)")]), _c('span', [_c('button', {
      staticClass: "-btn btn-link",
      staticStyle: {
        "color": "red"
      },
      attrs: {
        "type": "button",
        "title": "Download Rate"
      },
      on: {
        "click": function($event) {
          _vm.removeExceptionalCities()
        }
      }
    }, [_vm._v("Remove")])])])]) : _vm._e()]) : _vm._e()])
  }))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitMatrixData('save')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v("  \n      "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitMatrixData('saveAndNext')
      }
    }
  }, [_vm._v("Save and Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])]), _vm._v(" "), _c('br')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b7f37d1","hasScoped":true}!./src/modules/masterdata/views/ratetemplate/createratetemplate/baserate/baserate.component.html
// module id = 641
// module chunks = 3